import { memo } from 'react'

import { Text } from 'common-components'
import SuccessCheckmarkIcon from 'assets/svgr-icons/Success_Checkmark.svg'
import { SUCCESS_GREEN_COLOR } from 'consts/colors'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import { FRAMER_ANIMATION_PROPS } from '../consts'
import * as Styled from './styled'

const SuccessTtsGeneration: React.FC = () => {
  return (
    <Styled.SuccessButtonContainer {...FRAMER_ANIMATION_PROPS}>
      <SuccessCheckmarkIcon />
      <Text type="h4" customColor={SUCCESS_GREEN_COLOR}>
        {translate(T.COMPLETED)}
      </Text>
    </Styled.SuccessButtonContainer>
  )
}

export default memo(SuccessTtsGeneration)
